import React, { Fragment, useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom'

import { blockProductActions, createReservationActions } from '../../../redux/actions/reservationActions';
import { deleteProductAction } from '../../../redux/actions/productActions';

const SingleProductButtons = ({ product, user }) => {




    const dispatch = useDispatch();


    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState('');

    const [popupHeading, setpopupHeading] = useState('');
    const [popupPara, setpopupPara] = useState('');








    const handleReserve = () => {




        if (actionToPerform === 'reserve') {
            console.log(product?.id)

            dispatch(createReservationActions({ product_id: product?.id }))
        }

        if (actionToPerform === 'SYSTEM_CANCELLED' || actionToPerform === 'PAUSED' || actionToPerform === 'ACTIVE' || actionToPerform === 'INACTIVE') {

            dispatch(blockProductActions({ product_id: product?.id, status: actionToPerform }))
        } else if (actionToPerform === 'DELETE') {
            dispatch(deleteProductAction(product?.id))
        }

        setShowPopup(false)


    }


    const handleCancel = (statusVal) => {
        setShowPopup(true);


        if (statusVal === "SYSTEM_CANCELLED") {
            setpopupHeading('Cancel Product')
            setpopupPara(' Are you sure you want to cancel this product? This action cannot be undone.')
            setActionToPerform('SYSTEM_CANCELLED')

        } else if (statusVal === "PAUSED") {

            setpopupHeading('Pause Product')
            setpopupPara(' Are you sure you want to pause this product? Buyers Cannot place orders on this product until it is unpaused.')
            setActionToPerform('PAUSED')

        } else if (statusVal === "ACTIVE") {
            setpopupHeading('Active Product')
            setpopupPara(' Are you sure you want to activate this product? Buyers Can place orders on this product.')
            setActionToPerform('ACTIVE')

        } else if (statusVal === "INACTIVE") {
            setpopupHeading('Deactivate Product')
            setpopupPara(' Are you sure you want to deactivate this product? This action cannot be undone.')
            setActionToPerform('INACTIVE')
        } else if (statusVal === "DELETE") {
            setpopupHeading('Delete Product')
            setpopupPara('Are you sure you want to completely delete this product? This action cannot be undone.')
            setActionToPerform('DELETE')
        }


    }




    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    return (
        <Fragment>
            <div className="flex justify-center items-center px-[0.5vmax] w-[250px] flex-shrink-0 gap-[0.5vmax] relative" ref={dropdownRef}>
                <Link to={`/products/single-product?id=${product.id}`} className="flex-1 inline-flex items-center justify-center px-3 py-1.5 text-sm font-semibold rounded-lg bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 transition-all dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800 dark:hover:bg-blue-900/30" >
                    View
                </Link>
                
                {user?.role !== "PM" && (
                    <div className="relative flex-1">
                        <button 
                            className="w-full inline-flex items-center justify-center px-3 py-1.5 text-sm font-semibold rounded-lg bg-indigo-50 text-indigo-600 border border-indigo-100 hover:bg-indigo-100 transition-all cursor-pointer focus:outline-none flex items-center gap-1 dark:bg-indigo-900/20 dark:text-indigo-400 dark:border-indigo-800 dark:hover:bg-indigo-900/30"
                            onClick={() => setShowDropdown(!showDropdown)}
                        >
                            Status <i className={`fa-solid fa-chevron-down text-[0.7vmax] transition-transform ${showDropdown ? 'rotate-180' : ''}`}></i>
                        </button>
                        
                        {showDropdown && (
                            <div className="absolute bottom-[110%] right-0 bg-white border border-gray-100 rounded-lg shadow-lg z-[200] min-w-[140px] overflow-hidden py-1">
                                {product.status === "ACTIVE" && (
                                    <>
                                        <button className="w-full text-left px-4 py-2 text-[1.2vmax] lg:text-[0.85vmax] text-gray-700 hover:bg-gray-50 flex items-center gap-2 font-medium" onClick={() => { handleCancel("PAUSED"); setShowDropdown(false); }}>
                                            <i className="fa-solid fa-circle-pause text-orange-500 text-[1vmax] lg:text-[0.8vmax]"></i> Stop
                                        </button>
                                        <button className="w-full text-left px-4 py-2 text-[1.2vmax] lg:text-[0.85vmax] text-gray-700 hover:bg-gray-50 flex items-center gap-2 font-medium" onClick={() => { handleCancel("INACTIVE"); setShowDropdown(false); }}>
                                            <i className="fa-solid fa-circle-minus text-red-500 text-[1vmax] lg:text-[0.8vmax]"></i> Inactive
                                        </button>
                                        {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN") && (
                                            <button className="w-full text-left px-4 py-2 text-[1.2vmax] lg:text-[0.85vmax] text-gray-700 hover:bg-gray-50 flex items-center gap-2 font-medium" onClick={() => { handleCancel("SYSTEM_CANCELLED"); setShowDropdown(false); }}>
                                                <i className="fa-solid fa-circle-xmark text-red-600 text-[1vmax] lg:text-[0.8vmax]"></i> Cancel
                                            </button>
                                        )}
                                    </>
                                )}
                                {product.status === "PAUSED" && (
                                    <>
                                        <button className="w-full text-left px-4 py-2 text-[1.2vmax] lg:text-[0.85vmax] text-gray-700 hover:bg-gray-50 flex items-center gap-2 font-medium" onClick={() => { handleCancel("ACTIVE"); setShowDropdown(false); }}>
                                            <i className="fa-solid fa-circle-play text-green-500 text-[1vmax] lg:text-[0.8vmax]"></i> Resume
                                        </button>
                                        <button className="w-full text-left px-4 py-2 text-[1.2vmax] lg:text-[0.85vmax] text-gray-700 hover:bg-gray-50 flex items-center gap-2 font-medium" onClick={() => { handleCancel("INACTIVE"); setShowDropdown(false); }}>
                                            <i className="fa-solid fa-circle-minus text-red-500 text-[1vmax] lg:text-[0.8vmax]"></i> Inactive
                                        </button>
                                    </>
                                )}
                                {product.status === "INACTIVE" && (
                                    <button className="w-full text-left px-4 py-2 text-[1.2vmax] lg:text-[0.85vmax] text-gray-700 hover:bg-gray-50 flex items-center gap-2 font-medium" onClick={() => { handleCancel("ACTIVE"); setShowDropdown(false); }}>
                                        <i className="fa-solid fa-circle-check text-green-500 text-[1vmax] lg:text-[0.8vmax]"></i> Activate
                                    </button>
                                )}
                                {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN" || user?.role === "PMM") && (
                                    <button className="w-full text-left px-4 py-2 text-[1.2vmax] lg:text-[0.85vmax] text-red-600 hover:bg-red-50 flex items-center gap-2 font-medium border-t border-gray-100" onClick={() => { handleCancel("DELETE"); setShowDropdown(false); }}>
                                        <i className="fa-solid fa-trash-can text-red-600 text-[1vmax] lg:text-[0.8vmax]"></i> Delete
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {user?.role === "PM" && (
                    <button className={`flex-1 inline-flex items-center justify-center px-3 py-1.5 text-sm font-semibold rounded-lg transition-all border 
                    ${product.is_reserved ? "bg-gray-100 text-gray-400 border-transparent cursor-not-allowed dark:bg-gray-800 dark:text-gray-600" : "bg-indigo-50 text-indigo-600 border-indigo-200 hover:bg-indigo-100 dark:bg-indigo-900/20 dark:text-indigo-400 dark:border-indigo-800 dark:hover:bg-indigo-900/30"}`}
                        onClick={() => {
                            setShowPopup(true)
                            setActionToPerform('reserve')
                            setpopupHeading('Reserve Product')
                            setpopupPara('This Product will be reserved for 2 Hours. Are you sure you want to reserve this product?')
                        }}
                    >
                        {product.is_reserved ? "Reserved" : "Reserve"}
                    </button>
                )}
            </div>

            {showPopup && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 transform transition-all p-6">
                        
                        {/* Icon */}
                        <div className={`mx-auto w-12 h-12 rounded-full flex-center text-2xl mb-4
                            ${actionToPerform === 'reserve' ? "bg-indigo-50 text-indigo-600" :
                              actionToPerform === 'SYSTEM_CANCELLED' || actionToPerform === 'INACTIVE' ? "bg-red-50 text-red-600" :
                              actionToPerform === 'PAUSED' ? "bg-amber-50 text-amber-600" :
                              actionToPerform === 'ACTIVE' ? "bg-emerald-50 text-emerald-600" : "bg-zinc-50 text-zinc-600"}`}>
                            {actionToPerform === 'reserve' ? (
                                <i className="fa-solid fa-clock"></i>
                            ) : actionToPerform === 'SYSTEM_CANCELLED' || actionToPerform === 'INACTIVE' ? (
                                <i className="fa-solid fa-triangle-exclamation"></i>
                            ) : actionToPerform === 'PAUSED' ? (
                                <i className="fa-solid fa-circle-pause"></i>
                            ) : actionToPerform === 'ACTIVE' ? (
                                <i className="fa-solid fa-circle-check"></i>
                            ) : (
                                <i className="fa-solid fa-circle-question"></i>
                            )}
                        </div>

                        {/* Content */}
                        <div className="text-center">
                            <h3 className="font-bold text-lg text-zinc-800 font-jakarta mb-2">
                                {popupHeading}
                            </h3>
                            <p className="text-sm text-zinc-500 leading-relaxed whitespace-pre-line">
                                {popupPara}
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-3 mt-6">
                            {actionToPerform !== "HidePopup" && (
                                <button
                                    className="flex-1 text-zinc-600 font-semibold py-2.5 px-4 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all active:scale-[0.98]"
                                    onClick={() => {
                                        setShowPopup(false)
                                        setActionToPerform("")
                                    }}
                                >
                                    No
                                </button>
                            )}

                            <button
                                className={`flex-1 font-semibold py-2.5 px-4 rounded-xl text-white transition-all active:scale-[0.98]
                                    ${actionToPerform === 'reserve' ? "bg-gradient-to-r from-indigo-600 to-indigo-700 hover:shadow-lg hover:shadow-indigo-100" :
                                      actionToPerform === 'SYSTEM_CANCELLED' || actionToPerform === 'INACTIVE' ? "bg-gradient-to-r from-red-600 to-red-700 hover:shadow-lg hover:shadow-red-100" :
                                      actionToPerform === 'PAUSED' ? "bg-gradient-to-r from-amber-500 to-amber-600 hover:shadow-lg hover:shadow-amber-100" :
                                      actionToPerform === 'ACTIVE' ? "bg-gradient-to-r from-emerald-600 to-emerald-700 hover:shadow-lg hover:shadow-emerald-100" :
                                      "bg-gradient-to-r from-zinc-700 to-zinc-800"}`}
                                onClick={handleReserve}
                            >
                                Yes, Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default SingleProductButtons